export default function PricingCTA() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a4c8ebf6678fb2c0269f8b694e3f3fb8.jpg"
          alt="Cockpit sunset view"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/80 via-[#0A1628]/90 to-[#0A1628]"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-[#00FFD1]/10 border border-[#00FFD1]/30 rounded-full px-5 py-2 mb-8">
          <i className="ri-flight-takeoff-line text-[#00FFD1] text-sm"></i>
          <span className="text-[#00FFD1] text-sm font-medium uppercase tracking-widest">Ready to take off?</span>
        </div>

        <h2 className="text-5xl font-bold mb-6 leading-tight">
          Start flying smarter today
        </h2>
        <p className="text-xl text-gray-300 mb-12 leading-relaxed max-w-2xl mx-auto">
          Join thousands of pilots using WingmanFix to build safer habits and sharper skills — one flight at a time.
        </p>

        <div className="flex flex-wrap justify-center gap-5">
          <button className="bg-[#00A3E0] hover:bg-[#0088BB] text-white px-10 py-4 rounded-lg transition-all font-bold text-base shadow-2xl hover:shadow-[#00A3E0]/40 hover:scale-105 cursor-pointer whitespace-nowrap">
            <i className="ri-download-line mr-2"></i>Download WingmanFix
          </button>
          <button className="bg-white/10 backdrop-blur-sm border-2 border-white/60 text-white hover:bg-white/20 px-10 py-4 rounded-lg transition-all font-bold text-base cursor-pointer whitespace-nowrap">
            <i className="ri-question-line mr-2"></i>Talk to Sales
          </button>
        </div>

        <p className="mt-10 text-sm text-gray-500">
          No credit card required · 14-day free trial · Cancel anytime
        </p>
      </div>
    </section>
  );
}